export default __webpack_public_path__ + "static/media/4.f16f0b43.jpg";